export const config = {
  cywarenessLinkedin: 'https://www.linkedin.com/company/cywareness-io/',
  cywarenessHomepage: 'https://cywareness.io/',
  cloudinaryProductionDomain: 'media.cywareness.io',
  cloudinaryDevelopmentDomain: 'res.cloudinary.com',
  cloudinaryCoverImagesFolderProductionUrl: 'https://media.cywareness.io/image/upload/v1687682832',
  cloudinaryCoverImagesFolderDevelopmentUrl: 'https://res.cloudinary.com/cywareness-staging/image/upload/v1687762279',
}
